// Hidden intent → default rewrite-style mapping.
// Used by AnalysisCard to pre-select the post-result tab, and by ToneGuardPage
// to surface a tiny "Tone will default to …" pill so first-time users notice
// the smart default.

export const INTENT_TO_STYLE = {
    apologize: "warm",
    follow_up: "professional",
    set_boundary: "firm",
    ask_favor: "warm",
    clarify: "professional",
    express_concern: "warm",
    love: "warm",
};
